import { handleActions } from 'redux-actions';
import actionTypes from 'redux/common/action-types';
import Common from './type';

const initialState: Common = {
    userInfo: {
        user: {
            userId: 0,
            userName: '',
            headUrl: '',
        },
        dmpKeywordsUser: false,
        uploadUserId: false,
        adminUserId: 0,
        appId: 0,
        isCRMLogin: false,
        hiddenReport: false,
        dmpOrientationPush: false,
        dmpAccountsTransferData: false,
        dmpSQLCreateWhiteList: false,
        inetCelebrity: false,
        dmpClientTransferData: false,
        dmpFollowFavorWhiteList: false,
        dmpInvalidPortraitWhiteList: false,
        isKa: false,
        dmpAccountRevealWhiteList: false,
        dmpSecondOrientationPush: false,
        dmpSearchBehaviorWhiteList: false,
        dmpLargePOcreateWhiteList: false,
        adDmpTransformDataWhiteList: false,
        dmpDataInsightWhiteList: false,
        dmpECommerceWhiteList: false,
        dmpBrandDeviceWhiteList: false,
        dmpPropsDataSourceWhiteList: false,
        accountUcId: 0,
        dmpAccountsGidPermission: false,
        dmpStrategyQuoteEnable: false,
        dmpStrategyModuleEnable: false,
        dmpPopulationAnalysisWhiteList: false,
        secondIndustryName: '',
        dmpAdGuideReportAllowList: true,
    },
    authorizeAndType: {
        authorize: false,
        type: 'INTERNAL_CIRCULATION',
    },
    loginInfo: {
        userType: 'NORMAL',
        user: undefined,
    },
    populationTypes: [],
    tagCollection: [],
    tagListV2: [],
    portraitTagList: null,
    portraitModuleCondition: {
        selectTgi: 120,
        selectRate: 0.01,
    },

    // 暂时-开关状态
    isOpenSwitch: false,
};

export default handleActions(
    {
        [actionTypes.COMMON.GET_USER_INFO_SUCCESS]: (state, { payload }) => ({
            ...state,
            userInfo: payload.userInfo,
        }),
        [actionTypes.COMMON.GET_USER_MODEL_AUTH_SUCCESS]: (state, { payload }) => ({
            ...state,
            authorizeAndType: payload.authorizeAndType,
        }),
        [actionTypes.COMMON.GET_POPULATION_TYPES_SUCCESS]: (state, { payload }) => ({
            ...state,
            populationTypes: payload.populationTypes,
        }),
        [actionTypes.COMMON.GET_LOGIN_INFO_SUCCESS]: (state, { payload }) => ({
            ...state,
            loginInfo: payload.loginInfo,
        }),
        [actionTypes.COMMON.GET_COLLECTED_TAG_SUCCESS]: (state, { payload }) => ({
            ...state,
            tagCollection: [...state.tagCollection, ...payload.tagCollection],
        }),
        [actionTypes.COMMON.COLLECT_TAG_SUCCESS]: (state, { payload }) => ({
            ...state,
            tagCollection: [...state.tagCollection, ...payload.tagCollection],
        }),
        // 全部标签
        [actionTypes.COMMON.GET_TAG_LIST_SUCCESS]: (state, { payload }) => ({
            ...state,
            tagListV2: [...state.tagListV2, ...payload.tagListV2],
        }),
        [actionTypes.COMMON.UNCOLLECT_TAG_SUCCESS]: (state, { payload }) => {
            const newTagCollection = state.tagCollection.filter(
                (c) => c.tagId !== payload.tagCollection[0].tagId,
            );
            return {
                ...state,
                tagCollection: [...newTagCollection],
            };
        },
        [actionTypes.COMMON.PORTRAIT_TAG_LIST_SUCCESS]: (state, { payload }) => ({
            ...state,
            portraitTagList: payload.portraitTagList,
        }),
        [actionTypes.COMMON.PORTRAIT_MODULE_CONDITION_SUCCESS]: (state, { payload }) => ({
            ...state,
            portraitModuleCondition: {
                ...state.portraitModuleCondition,
                ...payload.portraitModuleCondition,
            },
        }),
        // 暂时-开关状态
        [actionTypes.COMMON.SWITCH_SUCCESS]: (state, { payload }) => ({
            ...state,
            isOpenSwitch: payload.isOpenSwitch,
        }),
    },
    initialState,
);
